import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, App, Space, Select } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import request from '../utils/request';

const Room = () => {
  const { message } = App.useApp();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingRecord, setEditingRecord] = useState(null);
  const [units, setUnits] = useState([]);

  useEffect(() => {
    fetchData();
    fetchUnits();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await request.get('/room');
      if (res.code === 200) {
        setData(res.data.list || []);
      }
      setLoading(false);
    } catch (error) {
      message.error('获取数据失败');
      setLoading(false);
    }
  };

  const fetchUnits = async () => {
    try {
      const res = await request.get('/unit');
      if (res.code === 200) {
        setUnits(res.data.list || []);
      }
    } catch (error) {
      console.error('获取单元失败');
    }
  };

  const handleAdd = () => {
    setEditingRecord(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await request.delete('/room/' + id);
      message.success('删除成功');
      fetchData();
    } catch (error) {
      message.error('删除失败');
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editingRecord) {
        await request.put('/room/' + editingRecord.id, values);
        message.success('更新成功');
      } else {
        await request.post('/room', values);
        message.success('创建成功');
      }
      setModalVisible(false);
      fetchData();
    } catch (error) {
      message.error(editingRecord ? '更新失败' : '创建失败');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    { title: '小区', dataIndex: 'community_name', key: 'community_name' },
    { title: '楼栋', dataIndex: 'building_name', key: 'building_name' },
    { title: '单元', dataIndex: 'unit_name', key: 'unit_name' },
    { title: '房号', dataIndex: 'number', key: 'number' },
    { title: '备注', dataIndex: 'remark', key: 'remark', ellipsis: true },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)}>编辑</Button>
          <Button type="link" danger icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)}>删除</Button>
        </Space>
      )
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>添加房号</Button>
      </div>

      <Table columns={columns} dataSource={data} rowKey="id" loading={loading} pagination={{ pageSize: 10 }} />

      <Modal
        title={editingRecord ? '编辑房号' : '添加房号'}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item label="所属单元" name="unit_id" rules={[{ required: true, message: '请选择单元' }]}>
            <Select placeholder="请选择单元">
              {units.map(u => <Select.Option key={u.id} value={u.id}>{u.building_name} - {u.name}</Select.Option>)}
            </Select>
          </Form.Item>
          <Form.Item label="房号" name="number" rules={[{ required: true, message: '请输入房号' }]}>
            <Input placeholder="请输入房号" />
          </Form.Item>
          <Form.Item label="备注" name="remark">
            <Input.TextArea rows={3} placeholder="请输入备注" />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">提交</Button>
              <Button onClick={() => setModalVisible(false)}>取消</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Room;
